module.exports = __webpack_public_path__ + "static/media/adhya.2837cf62.webp";